<div class="grid-container">
    <div class="grid-x">
        <div class="cell small-12 bold">
            Context Source for Casing Plan:
        </div>
        <div class="cell small-12">
            <input type="text" [(ngModel)]="casingPlanLocation" />
        </div>
        <div class="cell small-12 bold">
            Context Source for Application Number:
        </div>
        <div class="cell small-12">
            <input type="text" [(ngModel)]="applicationNumber" />
        </div>
        <div class="cell small-12 bold">
            Context Source for Well Name:
        </div>
        <div class="cell small=12">
            <input type="text" [(ngModel)]="wellName" />
        </div>
        <div class="cell small-12 bold">
            Context Source for Well Number:
        </div>
        <div class="cell small-12">
            <input type="text" [(ngModel)]="wellNumber" />
        </div>
    </div>
</div>
